<template>
  <div class="manage-layout">
    <ManageSidebar ref="sidebarRef" @collapse-change="handleCollapse" />
    <div class="manage-content" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <div class="content-header">
        <h1>{{ title }}</h1>
        <button class="logout-btn" @click="handleLogout">
          <span class="iconify mr-2" data-icon="hugeicons:logout-01"></span>
          退出登录
        </button>
      </div>
      <div class="content-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import ManageSidebar from './ManageSidebar.vue';

export default {
  name: 'ManageLayout',
  components: {
    ManageSidebar
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sidebarCollapsed: false
    };
  },
  methods: {
    handleCollapse(isCollapsed) {
      this.sidebarCollapsed = isCollapsed;
    },
    handleLogout() {
      // 清除token并跳转到登录页面
      localStorage.removeItem('token');
      this.$router.push('/manage/login');
    }
  }
};
</script>

<style>
/* 覆盖全局样式，确保管理员页面文字颜色正常 */
.manage-layout {
  color: #374151;
}

.manage-layout * {
  color: inherit;
}

/* 确保输入框和下拉框文字颜色正常 */
.manage-layout input,
.manage-layout select,
.manage-layout option {
  color: #374151 !important;
}
</style>

<style scoped>
.manage-layout {
  display: flex;
  min-height: 100vh;
}

.manage-content {
  flex: 1;
  margin-left: 240px;
  transition: margin-left 0.3s ease;
  background-color: #f9fafb;
}

.manage-content.sidebar-collapsed {
  margin-left: 64px;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background-color: white;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.content-header h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.logout-btn {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.logout-btn:hover {
  background-color: #dc2626;
}

.content-body {
  padding: 24px;
}

.mr-2 {
  margin-right: 8px;
}
</style>
